/**
 * @generated SignedSource<<b344d52188b5109c1036e8dd5792fab5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetTodoSummaryTodoCreatedSubscription$variables = {
  teamIds: ReadonlyArray<string>;
};
export type WidgetTodoSummaryTodoCreatedSubscription$data = {
  readonly todoCreated: {
    readonly category: {
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
        readonly notResolvedCount: number;
      }>;
    } | null;
  } | null;
};
export type WidgetTodoSummaryTodoCreatedSubscription = {
  response: WidgetTodoSummaryTodoCreatedSubscription$data;
  variables: WidgetTodoSummaryTodoCreatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "ids",
          "variableName": "teamIds"
        }
      ],
      "concreteType": "TodoCategoryTeam",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notResolvedCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTodoSummaryTodoCreatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoCreated",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetTodoSummaryTodoCreatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoCreated",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eb7e67da2e8f48d2f54f586ce8fdd542",
    "id": null,
    "metadata": {},
    "name": "WidgetTodoSummaryTodoCreatedSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetTodoSummaryTodoCreatedSubscription(\n  $teamIds: [ID!]!\n) {\n  todoCreated(teamIds: $teamIds) {\n    category {\n      id\n      teams(ids: $teamIds) {\n        id\n        notResolvedCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d843d625b5f6653cb4e7086517df1243";

export default node;
